
import InvoiceInfo from "models/invoice-info";
export default {
  data() {
    return {
      // 税率列表
      taxRateList: [
        { taxRate: '' }
      ],
      // 银行账号列表
      bankAccountNumberList: [],
    }
  },
  created() {
  },
  methods: {
    /** 
     * @description 税率详情
    */
    initTaxRateList() {
      InvoiceInfo.getTaxRateList().then(res => {
        if (res.success) {
          if (res.result) {
            if (res.result.length) {
              let arr = []
              res.result.map(i => {
                let obj = {}
                obj.taxRate = i
                arr.push(obj)
              })
              this.taxRateList = arr
            }
          } 
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /** 
     * @description 银行账号列表
    */
    initBankAccountNumberList() {
      InvoiceInfo.getBankAccountNumberList().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((value, index) => {
            let obj = {};
            obj.id = value.id;
            obj.sort = index + 1 < 10 ? `0${index + 1}` : index + 1;
            obj.status = value.status;
            obj.bankName = value.bankName;
            obj.bankAccount = value.bankAccount;
            obj.companyName = value.companyName;
            obj.companyCode = value.companyCode;
            obj.isMod = false
            arr.push(obj);
          });
          this.bankAccountNumberList = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
}